import * as React from "react";
import {useSelector} from "react-redux";
import moment from "moment";

import {dateFormat, rpeOptions} from "@/utils/constants";

import "./index.scss";

export default function RPECard(props) {
	const {element} = props;

	const userRole = useSelector((state) => state?.user?.roleName);
	const isPlayer = userRole === "Player";

	return (
		<div className="tqr-card-container">
			<div className="tqr-card-header">
				<div className="top-left">
					{moment(element.rpeDate).format(dateFormat)}
				</div>
				<div className="top-right">
					{!isPlayer
						? element.emptyRow
							? element.playerCategoryName
							: element.category?.name
						: undefined}
				</div>
			</div>
			<div className="tqr-card-info">
				<div className="info-title">
					<div className="tqr-info">
						{element.player
							? element.player.firstName + " " + element.player.lastName
							: "---"}
					</div>
				</div>
				<div className="info-subtitle">
					{rpeOptions.filter((o) => o.value === element.rpe)?.[0]?.label ||
						"Nessun dato inserito"}
				</div>
			</div>
		</div>
	);
}
